<template>
  <div class="news-modular">
    <div class="news-banner">
      <div class="news-title EC5 center">更多资讯</div>
    </div>
    <div class="news-content w1200">
      <div class="news-left">
        <el-breadcrumb
          v-if="$store.state.sceneClassName !== 'app'"
          class="news-nav"
          separator-class="el-icon-arrow-right"
        >
          <el-breadcrumb-item class="news-nav-a" :to="{ path: '/' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item class="news-nav-a">更多资讯</el-breadcrumb-item>
          <el-breadcrumb-item class="news-nav-a">快讯</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-list">
          <div v-for="item in 10" :key="`nl_${item}`" class="news-box">
            <router-link target="_blank" to="/newsDetail">
              <div class="read-img-box">
                <img
                  class="read-img"
                  :src="require('@/assets/images/news2.jpg')"
                  alt="好用的电商直播系统都有哪些功能"
                />
              </div>
            </router-link>
            <div class="read-content">
              <div class="read-title-sub">
                <router-link class="clickable" target="_blank" to="/newsDetail">
                  <div class="read-title">好用的电商直播系统都有哪些功能</div>
                </router-link>
                <div
                  v-if="$store.state.sceneClassName !== 'app'"
                  class="read-sub"
                >
                  从双十一到双十二再到即将到来的双旦，喜欢购物的你若是还不知道直播带货的话，那可就真的是OUT了！
                </div>
              </div>
              <div class="read-time">2020-12-24 10:57:16</div>
            </div>
          </div>
        </div>
        <div v-if="$store.state.sceneClassName !== 'app'" class="center">
          <el-pagination background layout="prev, pager, next" :total="1000">
          </el-pagination>
        </div>
        <div v-else class="more-btn center">
          <span v-if="isMore" class="MediumBtnType3" @click="showMore(false)"
            >收起报道</span
          >
          <span v-else class="MediumBtnType3" @click="showMore(true)"
            >查看更多</span
          >
        </div>
      </div>
      <div v-if="$store.state.sceneClassName !== 'app'" class="news-right">
        <div class="news-right-title">
          <div class="news-line"></div>
          <div class="hot-read-text">分类推荐</div>
        </div>
        <div class="type-list">
          <div class="type-item">
            <a href="/">小鹅学堂</a>
          </div>
          <div class="type-item">
            <a href="/">商业变现</a>
          </div>
          <div class="type-item">
            <a href="/">用户运营</a>
          </div>
          <div class="type-item">
            <a href="/">视频直播</a>
          </div>
          <div class="type-item">
            <a href="/">私域流量</a>
          </div>
          <div class="type-item">
            <a href="/">教育直播</a>
          </div>
          <div class="type-item">
            <a href="/">知识付费</a>
          </div>
          <div class="type-item">
            <a href="/">教育录播</a>
          </div>
          <div class="type-item">
            <a href="/">直播软件</a>
          </div>
        </div>

        <div class="news-right-title">
          <div class="news-line"></div>
          <div class="hot-read-text">热门推荐</div>
        </div>
        <div class="hot-read-list">
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/" target="_blank">有什么免费教学直播软件好用？</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/" target="_blank">教师手机录课软件</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/" target="_blank">手机录课用什么APP？</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/" target="_blank">PPT录课时把人像录进去</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/" target="_blank">有没有什么在线直播教育平台推荐？</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-free title="让您一分钟拥有自己的知识店铺" href="/"></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
export default {
  components: {
    'v-free': Free
  }
};
</script>

<style lang="scss">
.news-modular {
  .news-banner {
    height: 360px;
    padding-top: 160px;
    background: url('~@/assets/images/news1.png') center no-repeat;
    background-size: cover;
  }
  .news-banner .news-title {
    margin-bottom: 0;
    font-size: 64px;
    font-weight: 600;
  }
  .news-read {
    margin-top: 74px;
  }
  .news-read .hiddenInput {
    visibility: hidden;
    height: 0;
  }
  .news-read-banner {
    height: 260px;
    line-height: 260px;
    text-align: center;
    color: #fff;
    // background-image: url();
    background-color: #1472ff;
    font-size: 32px;
  }
  .news-content {
    margin: 0 auto 90px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .news-content .news-left {
    width: 768px;
  }
  .news-content .news-left .news-nav {
    padding: 24px 0 40px;
    line-height: 17px;
  }
  .news-content .news-left .news-nav .news-nav-a {
    color: #888;
    font-size: 12px;
    .el-breadcrumb__inner {
      color: inherit;
    }
    .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
      font-weight: normal;
      color: inherit;
    }
  }
  .news-content .news-left .news-nav .nav-arrows {
    width: 12px;
    height: 12px;
    position: relative;
    top: 2px;
  }
  .news-content .news-left .nodata {
    text-align: center;
    margin: 100px auto;
    color: #c9c9c9;
    font-size: 26px;
  }
  .news-content .news-left .news-list .news-item {
    width: 768px;
    height: 150px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 40px;
    cursor: pointer;
  }
  .news-content .news-left .news-list .news-box {
    width: 768px;
    height: 150px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 40px;
  }
  .news-content .news-left .read-img-box,
  .news-content .news-left .read-img-box .read-img {
    width: 200px;
    height: 150px;
    border-radius: 4px;
  }
  .news-content .news-left .news-list .news-box .clickable:hover .read-title {
    color: #1472ff;
  }
  .news-content .news-left .read-img-box {
    margin-right: 20px;
  }
  .news-content .news-left .read-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .news-content .news-left .read-content .read-sub,
  .news-content .news-left .read-content .read-title {
    width: 550px;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .news-content .news-left .read-content .read-title {
    font-size: 18px;
    color: #353535;
    line-height: 26px;
    font-weight: 700;
  }
  .news-content .news-left .read-content .read-sub {
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    color: #888;
  }
  .news-content .news-left .read-content .read-tabs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 8px 0 23px;
  }
  .news-content .news-left .read-content .read-tabs .read-tab-item {
    background-color: #e0ebff;
    color: #6b84b3;
    font-size: 12px;
    line-height: 18px;
    border-radius: 2px;
    padding: 0 4px;
    margin-right: 9px;
  }
  .news-content .news-left .read-content .read-time {
    font-size: 14px;
    line-height: 20px;
    color: #b2b2b2;
  }
  .news-content .news-left .news-check-more {
    width: 200px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #1472ff;
    color: #1472ff;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    margin: 0 auto 40px;
    cursor: pointer;
  }
  .news-content .news-right {
    width: 384px;
    margin-top: 80px;
  }
  .news-content .news-right .news-right-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 28px;
    margin-bottom: 16px;
  }
  .news-content .news-right .news-right-title .news-line {
    width: 4px;
    height: 22px;
    background: #1472ff;
    margin: 3px 8px 0 0;
  }
  .news-content .news-right .news-right-title .hot-read-text {
    font-size: 20px;
    font-weight: 500;
    color: #353535;
  }
  .news-content .news-right .type-list {
    margin-bottom: 32px;
  }
  .news-content .news-right .type-list::after {
    display: block;
    content: '';
    clear: both;
    overflow: hidden;
    zoom: 1;
  }
  .news-content .news-right .type-list .type-item {
    float: left;
    width: 86px;
    height: 28px;
    line-height: 28px;
    border-radius: 2px;
    border: 1px solid #8fc7ff;
    background-color: #fff;
    margin-left: 8px;
    margin-bottom: 8px;
    text-align: center;
    overflow: hidden;
    font-size: 12px;
    color: #353535;
    cursor: pointer;
  }
  .news-content .news-right .hot-read-list .hot-read-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
  .news-content .news-right .hot-read-list .hot-read-item .hot-read-date {
    width: 50px;
    color: #888;
    margin-right: 8px;
  }
  .news-content .news-right .hot-read-list .hot-read-item .hot-read-des {
    width: 332px;
    color: #353535;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  .news-content .news-right .hot-read-list .hot-read-item .hot-read-des:hover {
    color: #1472ff;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background: transparent;
    border: 1px solid #dfdfdf;
    box-sizing: border-box;
    min-width: 32px;
    height: 32px;
    line-height: 30px;
    border-radius: 4px;
    font-size: 14px;
    margin-left: 0;
    font-weight: 400;
    color: #1f1f1f;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active,
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    border: 1px solid #06f;
    background-color: #06f;
    color: #fff;
  }
}
.app .news-modular {
  padding-top: 1.04rem;
  .news-banner {
    height: 4rem;
    text-align: center;
    color: #fff;
    background-image: url(~@/assets/images/news1_app.png);
    background-color: #1472ff;
    background-size: cover;
    background-position: center;
    margin-bottom: 0.8rem;
    padding: 0;
    .news-title {
      line-height: 4rem;
      font-size: 0.48rem;
      font-weight: normal;
    }
  }
  .news-content {
    margin: 0;
  }
  .news-left {
    width: 100%;
    .news-list {
      padding: 0 0.3rem;
      .news-box {
        margin-bottom: 0.48rem;
        width: 100%;
        height: auto;
        background-color: #fff;
        box-shadow: 0 0 0.08rem 0 rgba(0, 0, 0, 0.08),
          0 0.4rem 0.8rem 0 rgba(0, 0, 0, 0.04);
        border-radius: 0.08rem;
        .read-img-box {
          width: 2.88rem;
          height: 2.16rem;
          margin: 0;
          img {
            width: 100%;
            height: auto;
            min-height: 100%;
          }
        }
        .read-content {
          padding: 0.16rem 0.24rem;
        }
        .read-title {
          font-size: 0.28rem;
          line-height: 0.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          width: 3.6rem;
          word-break: break-all;
        }
        .read-time {
          font-size: 0.24rem;
          color: #b2b2b2;
          line-height: 0.36rem;
        }
      }
    }
  }
  .more-btn {
    margin: 0.96rem auto 1.6rem;
    .MediumBtnType3 {
      width: 4rem;
      height: 0.96rem;
      border-radius: 0.08rem;
      line-height: 0.96rem;
      font-size: 0.32rem;
      padding: 0;
    }
  }
}
</style>
